const emptyArray = [];
const CLIP_ITEM = 'clip';

export const getClippedStandings = (props, standings) => {
  if (standings) {
    const teamsByPosition = new Map();
    // Find the teams and add them
    const homeTeam = standings.find(
      (standing) => standing.teamAbbrv === props.homeTeamAbbrv
    );
    const visitingTeam = standings.find(
      (standing) => standing.teamAbbrv === props.visitingTeamAbbrv
    );

    if (!homeTeam || !visitingTeam) {
      return emptyArray;
    }
    teamsByPosition.set(homeTeam.position, homeTeam);
    teamsByPosition.set(visitingTeam.position, visitingTeam);

    // Add teams above and below for both teams
    if (homeTeam.position > 1) {
      const team = standings[homeTeam.position - 2];
      teamsByPosition.set(team.position, team);
    }
    if (homeTeam.position < standings.length) {
      const team = standings[homeTeam.position];
      teamsByPosition.set(team.position, team);
    }
    if (visitingTeam.position > 1) {
      const team = standings[visitingTeam.position - 2];
      teamsByPosition.set(team.position, team);
    }
    if (visitingTeam.position < standings.length) {
      const team = standings[visitingTeam.position];
      teamsByPosition.set(team.position, team);
    }
    // Do we need a clip item in between?
    if (Math.abs(homeTeam.position - visitingTeam.position) > 3) {
      if (homeTeam.position < visitingTeam.position) {
        teamsByPosition.set(homeTeam.position + 2, {
          type: CLIP_ITEM,
          position: homeTeam.position + 2,
        });
      } else {
        teamsByPosition.set(visitingTeam.position + 2, {
          type: CLIP_ITEM,
          position: visitingTeam.position + 2,
        });
      }
    }
    let standingsToShow = Array.from(teamsByPosition.values());
    standingsToShow = standingsToShow.sort((a, b) => {
      if (a.position < b.position) return -1;
      if (a.position > b.position) return 1;
      return 0;
    });

    // Do we still have fewer than 5 items?
    if (standingsToShow.length < 5 && standingsToShow[0].position > 1) {
      standingsToShow.splice(0, 0, standings[standingsToShow[0].position - 2]);
    }
    const toShowLastTeam = standingsToShow[standingsToShow.length - 1];
    const totalLastTeam = standings[standings.length - 1];
    if (
      standingsToShow.length < 5 &&
      toShowLastTeam.position < totalLastTeam.position
    ) {
      standingsToShow.push(standings[toShowLastTeam.position]);
    }
    return standingsToShow;
  }
  return emptyArray;
};
